"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Migraine = void 0;
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = __importStar(require("react-native-svg"));
function Migraine({ active }) {
    const styles = {
        strokeColor: {
            stroke: active ? '#fff' : '#3db384',
            strokeWidth: 1.13,
            fill: 'none',
        },
    };
    return (react_1.default.createElement(react_native_svg_1.default, { viewBox: "0 0 48.26 52.52" },
        react_1.default.createElement(react_native_svg_1.Path, { stroke: active ? '#fff' : '#3db384', fill: "none", d: "M24 43.51s-.09 5.86 4.79 5.86 9.57-.09 9.57-.09 2 .26 2.4-2.75.44-2.93.44-2.93l1.24-6.38 5.06-1-4.5-10.7s.36-8.6-1.59-13.12A18.62 18.62 0 0027.2 1.22 22.68 22.68 0 005.93 7.87C.7 13.55-.37 23 1.85 28.53S5.93 35 5.93 38.64v13.12M26.32 11.72a8.65 8.65 0 11-7.89.27" }),
        react_1.default.createElement(react_native_svg_1.Path, { stroke: active ? '#fff' : '#3db384', fill: "#fff", d: "M22.64 21.53a2 2 0 112-2 2 2 0 01-2 2" })));
}
exports.Migraine = Migraine;
